import Http from '@/api/http/';

export default class VirtualTask extends Http {
  constructor() {
    super();
  }
  // 获取虚拟任务列表
  virtualTask_getList() {
    return super.post('virtualTask/getList', ...arguments);
  }
  // 批量下载
  virtualTask_export() {
    return super.post('virtualTask/export', ...arguments);
  }
  // 设置虚拟任务奖励
  virtualTask_setVirtualTaskScore() {
    return super.post('virtualTask/setVirtualTaskScore', ...arguments);
  }
  // 获取虚拟任务奖励
  virtualTask_getVirtualTaskScore() {
    return super.post('virtualTask/getVirtualTaskScore', ...arguments);
  }
  // 获取虚拟任务详情
  virtualTask_getVirtualTaskInfo() {
    return super.post('virtualTask/getVirtualTaskInfo', ...arguments);
  }
}
